import React, { useState, useEffect } from 'react'
import { useFetch } from '../../hooks/useFetch'
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
    GridHeader,
    GridFooter,
    GridFooterContainer
} from '@mui/x-data-grid';
import format from 'date-fns/format'
import { Container, Box, Grid, TextField, Typography, Button, Divider, Card, Paper, CardActions, CardContent } from '@mui/material/'

function ViewOrderTotal({ orderId }) {


    const [totalDesc, setTotalDesc] = useState('')
    const { error, errorMessage, isPending, data } = useFetch(`https://dcregapi.bi-oss.co.za/orders/total/${orderId}`,)





    useEffect(() => {
        if (data) {
            data.map(data => (

                setTotalDesc(data.QuoteTotal)

            ))
        }
    }, [data])


    return (
        <GridFooterContainer>
            <GridFooter sx={{
                border: 'none', // To delete double border.
            }} />

            {isPending && (
                <Typography fullWidth variant="h6" component="h6" color="primary.main" sx={{ textAlign: 'center', marginRight: "50px" }}>Calculating total….</Typography>

            )}

            {!isPending && (
                <Typography fullWidth variant="h6" component="h6" color="primary.main" sx={{ textAlign: 'center', marginRight: "50px" }}>Total Due: {totalDesc}</Typography>

            )}





        </GridFooterContainer>
    )
}

export default ViewOrderTotal